<div class="d-grid grid-congruent">
  <div class="form-floating" aria-hidden="true">
    <div class="form-control h-auto visually-hidden" style="white-space: pre-wrap">
      {{ formControlDirective.control?.value }}
    </div>
  </div>
  <div class="d-flex form-floating h-100">
    @if (inputElem.content?.before) {
      {{ inputElem.content?.before }}
    }
    <textarea
      [attr.type]="inputElem.dataType || 'text'"
      [ngClass]="{
        'pl-2': inputElem.inputPrependLabelKey,
        'is-valid':
          inputElem.validateSuccess &&
          parentForm.controls[inputElem.name].status === 'VALID' &&
          !parentForm.controls[inputElem.name].pristine,
        'is-invalid': parentForm.controls[inputElem.name].errors && !parentForm.controls[inputElem.name].pristine,
        'form-control': !isInline,
      }"
      rows="2"
      class="{{ inputElem.inputCssClass }}"
      [attr.id]="inputElem.name"
      [attr.name]="inputElem.name"
      [attr.data-test]="'form-input-' + inputElem.name"
      [formControl]="parentForm.controls[inputElem.name]"
      [attr.maxlength]="inputElem.maxLength || null"
      [attr.placeholder]="inputElem.placeholder | translate"
      [attr.style]="'height: unset;' + inputElem.inputStyle"
      [attr.avoidCopyPaste]="inputElem.avoidCopyPaste || false"
      [mweBlockPasteEvent]="inputElem.avoidCopyPaste"
      (blur)="inputBlurred.emit()"
      [attr.disabled]="inputElem.isDisabled ? '' : null"
      [attr.readonly]="isLoading || inputElem.isReadonly ? 'readonly' : null"
      (input)="handleInput($event)"
      (keydown.enter)="onEnterPressed($event)"
      [attr.aria-describedby]="ariaDescribedBy || null"
      [attr.aria-invalid]="!isValid"
      [attr.aria-label]="(inputElem.ariaLabel | translate) || null"
      [attr.aria-labelledby]="inputElem.ariaLabelledby || null"
      [attr.autocomplete]="inputElem.noAutocomplete ? 'off' : null"
      [required]="isRequired || null"
    ></textarea>
    @if (inputElem.labelKey) {
      <label [attr.for]="inputElem.name" class="form-label z-1" [ngClass]="inputElem.labelCss" [translate]="inputElem.labelKey"></label>
    }
    @if (inputElem.loadingSpinnerOptions) {
      <mwe-form-input-loading-spinner
        [inputElem]="inputElem"
        [currentValue]="currentValue"
        [isValid]="isValid"
        (isLoading)="isLoading = $event"
        [suppressValidityCheckOnSubmit]="inputElem.loadingSpinnerOptions?.suppressValidityCheckOnSubmit"
      />
    }
    @if (inputElem.toggleIcon) {
      <div class="form-floating-icon">
        <button class="btn btn-clean" (click)="togglePassword($event)">
          <i class="fas" [ngClass]="inputElem.dataType === 'password' ? 'fa-eye' : 'fa-eye-slash'"></i>
        </button>
      </div>
    }
    @if (inputElem.content?.after) {
      {{ inputElem.content?.after }}
    }
  </div>
</div>
